import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useMessagesLive } from "../live/useMessagesLive";
import { channelKey, MessagesChannel } from "../models/MessagesChannel";
import { selectUnreadCount } from "../selectors/messages-selectors";
import { fetchUnreadCount } from "../slice-extensions/messages-slice-extension";
import { usePolling } from "./usePolling";

/**
 * The reader's unread count for a nav item while `enabled`: refetched on the live signal, and
 * every 30 s only while the live connection is down.
 */
export const useUnreadCount = (channel: MessagesChannel | null, enabled = true): number => {
  const dispatch = useAppDispatch();
  const count = useAppSelector(selectUnreadCount(channel ?? { kind: "staff" }));
  const active = enabled && channel !== null;
  const refresh = () => {
    if (channel) dispatch(fetchUnreadCount(channel));
  };
  const live = useMessagesLive(active ? channel : null, { onUnreadChanged: refresh, onResync: refresh });
  usePolling(refresh, active && live !== "connected", channel ? channelKey(channel) : "");
  return channel ? count : 0;
};
